import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import MembNrmlLoginApi from 'Apis/MembNrmlLoginApi';
import { useState ,useCallback, useRef} from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate , Link} from "react-router-dom";
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import SsoLoginUi from './SsoLoginUi';
import CbtMembJoinLink from './CbtMembJoinLink';
import {useDispatch} from 'react-redux';
import { IdntMthdCdStateChng } from 'Stores/IdntMthdCdReducer';
import useRecaptcha from 'Utils/useRecaptcha';
import { validateInput } from 'Utils/XssFilter';
import { useAsyncAction } from 'hooks/useAsyncAction';
import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
import AthnQrLoginUrlApi from 'Apis/AthnQrLoginUrlApi';
import AthnQrLoginSseApi from 'Apis/AthnQrLoginSseApi';
import AthnQrLoginCmplApi from 'Apis/AthnQrLoginCmplApi';
import {QRCodeCanvas} from 'qrcode.react';
import { Check, LoaderCircle, RefreshCw, X } from 'lucide-react';


const CbtLoginPage = () => {
    const { push: gtmPush } = useGtm();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // 리퍼러 파라미터 가져오기
    const params = new URLSearchParams(window.location.search);
    const referrerParam = params.get("referrer");
    const referrer = (referrerParam && referrerParam !== "null") ? referrerParam : null;
    const [qrLoginUrl, setQrLoginUrl] = useState("");
    const [validSec, setValidSec] = useState(0);
    const [isQrRefreshing, setIsQrRefreshing] = useState(false);
    const [qrLoginStatus, setQrLoginStatus] = useState("ISSU");
    const [isAppDownloadOpen, setIsAppDownloadOpen] = useState(false);
    const [loginId,setLoginId] = useState("");
    const [passwd,setPasswd] = useState("");
    const [loginAlertTxt,setloginAlertTxt] = useState("");
    const qrLoginEventSourceRef = useRef<EventSource | null>(null);
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const LoginIdHandler = (event:any) => {
        // XSS 필터링 적용 - 패턴 제거 없이 감지만
        const filteredValue = validateInput(event.currentTarget.value, 'loginId', false);
        setLoginId(filteredValue);
        setloginAlertTxt("");
    }
    const PasswdHandler = (event:any) => {
        // XSS 필터링 적용 - 패턴 제거 없이 감지만
        const filteredValue = validateInput(event.currentTarget.value, 'password', false);
        setPasswd(filteredValue);
        setloginAlertTxt("");
    }
    const membJoinLinkTxt = [langData&&langData.LOGIN_FIND_LOGIN_ID_BTN_00,langData&&langData.LOGIN_FIND_PASSWD_MAIN_BTN_00,langData&&langData.LOGIN_MEMB_JOIN_MAIN_BTN_00];
    const { getToken } = useRecaptcha();

    const syncIdntMthdCdToStore = (resp: any) => {
        const rawValue = resp?.apiBody?.idntMthdCd ?? resp?.apiBody?.param;
        const normalized = String(rawValue || "").toUpperCase();
        if (normalized === "NA" || normalized === "EML" || normalized === "MBP") {
            dispatch(IdntMthdCdStateChng(normalized));
        }
    };

    // Async login function for useAsyncAction hook
    const performLogin = async () => {
        let token = '';
        try {
            token = await getToken('login');
        } catch (err) {
            setloginAlertTxt(langData && langData.COMM_CPTCH_ERROR_DESC_00 || 'reCAPTCHA 실행 실패. 잠시 후 다시 시도해주세요.');
            return;
        }
        const Resp = await MembNrmlLoginApi(loginId, passwd, token);

        syncIdntMthdCdToStore(Resp);
        
        switch(Resp.apiHdr.code) {
            case "ATHN0000": {
                    const tsKst = getKstTimestamp();
                    const adPayload = await fetchAdPayload( 'BBO');
                    if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                    }
                    try {

                        gtmPush('BBO_GA_Login_Complete', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Login_Complete',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                // 리퍼러 파라미터가 있으면 해당 페이지로 이동
                if(Resp.apiBody?.redirectUri.length > 0) {
                     return navigate(decodeURIComponent(Resp.apiBody.redirectUri), { replace: true });
                }
           
                if (referrer) {
                    navigate(decodeURIComponent(referrer), { replace: true });
                } else {
                    navigate("/", { replace: true });
                }

            }
            break;
            case"ATHN2002":
                navigate("/BlckMemb",{state:{loginId:loginId},replace:true});
            break;
            case"ATHN2005":
                navigate("/membLvdCncl",{state:{loginId:loginId},replace:true});
            break; 
            case "ATHN2007": {
                // 현재 리퍼러 파라미터를 OTP 페이지로 넘김
                const otpState = { idntMthdCd: Resp.apiBody?.param };
                if (referrer) {
                    navigate(`/OtpAthn?referrer=${encodeURIComponent(referrer)}`, { state: otpState });
                } else {
                    navigate("/OtpAthn", { state: otpState });
                }
            }
            break;
            case"ATHN2003":
                navigate("/DrmcMemb",{state:{loginId:loginId},replace:true});
            break;        
            case"ATHN2309":
            case"ATHN2000":
                setloginAlertTxt(langData&&langData.LOGIN_MAIN_RSLT_DESC_00);
            break;
            case"ATHN2313":
                setloginAlertTxt(langData&&langData.LOGIN_TOO_MANY_TRY_00);
            break;
            default:
                setloginAlertTxt(`${Resp.apiHdr.msg}`);
            break;
        }
        
            // no refresh state needed; executeRecaptcha will request fresh token next time
    };

    // Use async action hook to prevent duplicate login attempts
    const executeLogin = useAsyncAction(performLogin);

    const MembLoginFunc = (e:any) => {
        e.preventDefault();
        if(!loginId) {
            setloginAlertTxt(langData&&langData.LOGIN_MAIN_LOGIN_INPUT_DESC_00);
            // 아이디를 입력해주세요.
        }else if(!passwd){
            setloginAlertTxt(langData&&langData.LOGIN_PAGE_PASSWD_INPUT_DESC_00)
            //비밀번호를 입력해주세요.
        }else {
            executeLogin();
        }
    }

    const requestQrLogin = useCallback(async () => {
        setIsQrRefreshing(true);
        try {
            const data = await AthnQrLoginUrlApi();
            if(data?.apiBody?.qrLoginUrl) {
                setQrLoginStatus("ISSU");
                setValidSec(Math.max(Number(data.apiBody.validSec) || 0, 0));
                setQrLoginUrl(data.apiBody.qrLoginUrl);
                qrLoginEventSourceRef.current?.close();
                qrLoginEventSourceRef.current = AthnQrLoginSseApi(
                    async (eventType, sseData) => {
                        console.log(`QR 로그인 SSE ${eventType}`, sseData);

                        if(eventType === "message") return;
                        setQrLoginStatus(eventType);

                        if(eventType === "EXPR") {
                            setValidSec(0);
                            return;
                        }

                        if(eventType === "RJCT") {
                            qrLoginEventSourceRef.current?.close();
                            qrLoginEventSourceRef.current = null;
                            setValidSec(0);
                            return;
                        }

                        if(eventType === "APRV") {
                            const approvedAt = Date.now();
                            qrLoginEventSourceRef.current?.close();
                            qrLoginEventSourceRef.current = null;
                            const completionData = await AthnQrLoginCmplApi();

                            if(completionData?.apiHdr?.code === "ATHN0000") {
                                const remainingDelay = Math.max(1000 - (Date.now() - approvedAt), 0);
                                await new Promise((resolve) => window.setTimeout(resolve, remainingDelay));
                                const redirectUri = completionData.apiBody?.redirectUri;
                                if(redirectUri) {
                                    navigate(decodeURIComponent(redirectUri), { replace: true });
                                } else if(referrer) {
                                    navigate(decodeURIComponent(referrer), { replace: true });
                                } else {
                                    navigate("/", { replace: true });
                                }
                            } else {
                                setQrLoginStatus("EXPR");
                                setValidSec(0);
                                setloginAlertTxt(completionData?.apiHdr?.msg || "QR 로그인에 실패했습니다.");
                            }
                        }
                    },
                    (readyState) => {
                        if(readyState === EventSource.CLOSED) {
                            console.error("QR 로그인 SSE 연결이 종료되었습니다.");
                        }
                    },
                    () => console.info("QR 로그인 SSE 연결 완료"),
                );
            }
        } finally {
            setIsQrRefreshing(false);
        }
    }, [navigate, referrer]);

    useEffect(() => {
        requestQrLogin();

        return () => {
            qrLoginEventSourceRef.current?.close();
            qrLoginEventSourceRef.current = null;
        };
    }, [requestQrLogin]);

    useEffect(() => {
        if(!qrLoginUrl) return;
        if(validSec <= 0) {
            qrLoginEventSourceRef.current?.close();
            qrLoginEventSourceRef.current = null;
            return;
        }

        const timer = window.setTimeout(() => {
            setValidSec((seconds) => Math.max(seconds - 1, 0));
        }, 1000);

        return () => window.clearTimeout(timer);
    }, [qrLoginUrl, validSec]);

    const isQrScanning = qrLoginStatus === "SCAN";
    const isQrApproved = qrLoginStatus === "APRV";
    const isNonProductionHost = /(^localhost$|^127\.0\.0\.1$|-dev\.|-alpha\.|-beta\.)/i.test(window.location.hostname);
    const appDownloadUrl = isNonProductionHost
        ? "https://app-dev.bearbrickconnect.com/go/home"
        : "https://app.bearbrickconnect.com/go/home";
    const qrStatusText = qrLoginStatus === "RJCT"
        ? "앱에서 로그인을 취소했습니다"
        : validSec <= 0
            ? "QR 코드가 만료되었습니다."
            : null;

    return(
        <>
        <div className='loginInputWrap qrLoginPage'>
            <Helmet>
                <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}`}</title>
            </Helmet>
            <div className="qrLoginFormColumn">
                <form action="" onSubmit={MembLoginFunc}>
                    <ul className='loginInputUl'>
                        <li>
                            <input placeholder={`${langData&&langData.LOGIN_MAIN_LOGIN_ID_LBL_00}`} className='idInput' onChange={LoginIdHandler}></input>
                        </li>
                        <li>
                            <input placeholder={`${langData&&langData.LOGIN_MAIN_PASSWD_MAIN_LBL_00}`} type='password' className='passwdInput' autoComplete="off" onChange={PasswdHandler}></input>
                        </li>
                        <p className='loginAlertTxt'>{loginAlertTxt}</p>
                    </ul>
                    
                    <button className='loginBtn' type='submit'>{langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}</button>
                    {/* <Link to={referrer||"/"} className='cbtHomeBtn'><p>이전 페이지로 이동</p></Link> */}
                    {/* 로그인 */}
                </form>
                <SsoLoginUi referrer={referrer} viewType='page'/>
                <CbtMembJoinLink referrer={referrer} membJoinLinkTxt={membJoinLinkTxt} noWrap/>
                <div className="capthCpyr">
                    <p>
                        This site is protected by reCAPTCHA and the Google
                        <br />
                        <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                        <a href="https://policies.google.com/terms"  target="_blank">Terms of Service</a> apply.
                    </p>
                </div>
            </div>
            {/* <div className='membIconWrap'>
                <h1>{langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}</h1>
            </div> */}
            {qrLoginUrl && (
                <div className="qrLoginPanel">
                    <div className="qrLoginCodeWrap">
                        <h2>또는 QR 코드로 로그인</h2>
                        <div className="qrLoginImageFrame">
                            <div className={`qrLoginImage${validSec <= 0 || isQrScanning || isQrApproved ? " isBlurred" : ""}${isAppDownloadOpen ? " isHidden" : ""}`}>
                                <div className="qrLoginCanvas">
                                    <QRCodeCanvas value={qrLoginUrl} size={180} />
                                </div>
                            </div>
                            {isQrScanning && (
                                <div className="qrLoginLoadingOverlay" role="status" aria-label="QR 로그인 승인 대기 중">
                                    <span className="qrLoginLoadingBadge">
                                        <LoaderCircle className="qrLoginLoadingIcon" size={40} aria-hidden="true" />
                                    </span>
                                </div>
                            )}
                            {isQrApproved && (
                                <div className="qrLoginLoadingOverlay qrLoginApprovedOverlay" role="status" aria-label="로그인 승인 완료">
                                    <Check size={44} strokeWidth={3} aria-hidden="true" />
                                </div>
                            )}
                            {validSec <= 0 && !isQrApproved && (
                                <button
                                    type="button"
                                    onClick={requestQrLogin}
                                    disabled={isQrRefreshing}
                                    aria-label={isQrRefreshing ? "QR 새로고침 중" : "QR 새로고침"}
                                    title={isQrRefreshing ? "새로고침 중" : "QR 새로고침"}
                                    className="qrLoginRefreshButton"
                                >
                                    <span>
                                        <RefreshCw size={24} aria-hidden="true" />
                                    </span>
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="qrLoginStatus">
                        {qrStatusText && (
                            <p aria-live="polite">
                                {qrStatusText}
                            </p>
                        )}
                    </div>
                    <p className="qrLoginGuide">
                        <button type="button" onClick={() => setIsAppDownloadOpen(true)}>CONNECT 앱</button>을 사용하여<br />
                        QR 코드로 로그인
                    </p>
                </div>
            )}
            {isAppDownloadOpen && createPortal(
                (
                    <div className="qrAppDownloadOverlay" onClick={() => setIsAppDownloadOpen(false)}>
                        <section
                            className="qrAppDownloadModal"
                            role="dialog"
                            aria-modal="true"
                            aria-labelledby="qrAppDownloadTitle"
                            onClick={(event) => event.stopPropagation()}
                        >
                            <button
                                type="button"
                                className="qrAppDownloadClose"
                                onClick={() => setIsAppDownloadOpen(false)}
                                aria-label="CONNECT 앱 받기 닫기"
                            >
                                <X size={22} aria-hidden="true" />
                            </button>
                            <h2 id="qrAppDownloadTitle">CONNECT 앱 받기</h2>
                            <div className="qrAppDownloadCode">
                                <QRCodeCanvas value={appDownloadUrl} size={132} />
                            </div>
                            <p>휴대폰 카메라로 스캔하면<br />설치 페이지로 이동합니다</p>
                            <div className="qrAppStoreLinks">
                                <a href="https://apps.apple.com/kr/app/bearbrick-connect/id6777928150" target="_blank" rel="noopener noreferrer">App Store</a>
                                <a href="https://play.google.com/store/apps/details?id=com.bearbrick.connect" target="_blank" rel="noopener noreferrer">Google Play</a>
                            </div>
                            <small>휴대폰 카메라로 로그인 QR을 찍어도<br />CONNECT 앱으로 바로 이어집니다</small>
                        </section>
                    </div>
                ),
                document.body,
            )}
        </div>
        </>
    )
}

export default CbtLoginPage;